import EventBus from '@/utils/eventBus';

export const LIMITE_API_EXTERNA_CODE = 'LIMITE_API_EXTERNA';

export function getLimiteApiExternaPayload(responseOrData) {
    const data = responseOrData && responseOrData.data != null
        ? responseOrData.data
        : responseOrData;
    if (!data || typeof data !== 'object') {
        return null;
    }
    if (data.codigo === LIMITE_API_EXTERNA_CODE || data.code === LIMITE_API_EXTERNA_CODE) {
        return data;
    }
    return null;
}

export function isLimiteApiExternaAxiosError(error) {
    return !!(error && error.response && getLimiteApiExternaPayload(error.response));
}

export function notifyLimiteApiExternaError(error) {
    if (!error || error._limiteApiExternaDisplayed) {
        return;
    }
    EventBus.$emit('show-error', { error, type: 'API' });
}

export function markLimiteApiExternaDisplayed(error) {
    if (error) {
        error._limiteApiExternaDisplayed = true;
    }
}
